import styles from './SectionBlock.module.css'

interface SectionBlockProps {
  number: string | number
  title: string
  variant?: 'default' | 'inspiration' | 'team'
  children: React.ReactNode
}

export default function SectionBlock({ number, title, variant = 'default', children }: SectionBlockProps) {
  const numStr = String(number).padStart(2, '0')
  const wrapClass = variant === 'inspiration' ? styles.inspiration
    : variant === 'team' ? styles.team
    : styles.section

  return (
    <div className={wrapClass} data-testid={`section-${numStr}`}>
      <div className={styles.label}>
        <span className={`${styles.num} ${variant === 'team' ? styles.numTeam : variant === 'inspiration' ? styles.numDefault : ''}`}>
          {numStr}
        </span>
        {title}
      </div>
      {children}
    </div>
  )
}
